var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { ContainerLayout } from "../components/ContainerLayout";
import AppBarHeader from "../components/Home/AppBarHeader";
import { NaoEncontrado } from "../components/NaoEncontrado";
export var UsuarioInexistente = function () {
    return (_jsxs(_Fragment, { children: [_jsx(AppBarHeader, { titulo: "DETRAN MT - Portal de Servi\u00E7os", isHome: true }), _jsx(Box, __assign({ mt: "4rem" }, { children: _jsx(ContainerLayout, { children: _jsx(NaoEncontrado, { subtitulo: "N\u00E3o foi encontrado nenhuma informa\u00E7\u00E3o do usu\u00E1rio logado nos sistemas do DETRAN-MT." }) }) }))] }));
};
